import { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import moment from "moment-jalaali";
import { useNavigate } from "react-router-dom";
import { TextContext } from "../context/TextContext";
import { getAbsencesOfDay, RemoveAbsence } from "../api/absenceService";

const DayAbsences = () => {
    const navigate = useNavigate();

    const { selectedDate } = useContext(TextContext);

    const [isLoading, setIsLoading] = useState(true);
    const [students, setStudents] = useState([]);
    const [removingId, setRemovingId] = useState(null);

    useEffect(() => {
        if (selectedDate != null) {
            getAbsences();
        } else {
            navigate("/", { replace: false });
        }
    }, []);

    const getAbsences = async () => {
        try {
            setIsLoading(true);

            const data = await getAbsencesOfDay(selectedDate);

            setStudents(data.absences || []);
        } catch (err) {
            toast.error(
                err.response?.data?.message ||
                "دریافت اطلاعات غیبت‌ها با خطا مواجه شد."
            );
        } finally {
            setIsLoading(false);
        }
    };

    const removeAbsenceHandler = async (studentId) => {
        const student = students.find(
            (item) => item.studentId === studentId
        );

        if (!student) return;

        const confirmed = window.confirm(
            `آیا از حذف غیبت «${student.name} ${student.family}» مطمئن هستید؟`
        );

        if (!confirmed) return;

        try {
            setRemovingId(studentId);

            await RemoveAbsence(studentId, selectedDate);

            setStudents((current) =>
                current.filter(
                    (item) => item.studentId !== studentId
                )
            );

            toast.success("غیبت با موفقیت حذف شد.");
        } catch (err) {
            toast.error(
                err.response?.data?.message ||
                "حذف غیبت انجام نشد."
            );
        } finally {
            setRemovingId(null);
        }
    };

    const getHrefSms = (e) => {
        const mobiles = students
            .map((student) => student.parentMobile)
            .filter(Boolean);

        if (!mobiles.length) {
            e.preventDefault();

            toast.info("شماره‌ای برای ارسال پیام وجود ندارد.");
            return;
        }

        e.currentTarget.href =
            "sms:" + mobiles.join(",") + ";&body=";
    };

    const dayName = selectedDate
        ? moment(selectedDate, "YYYY-MM-DD").format("dddd")
        : "";

    const formattedDate = selectedDate
        ? moment(selectedDate, "YYYY-MM-DD").format("jD jMMMM jYYYY")
        : "";

    return (
        <div className="absence-page" dir="rtl">

            {/* ================= HEADER ================= */}

            <header className="absence-header">

                <div className="absence-header-inner">

                    <div className="header-title">
                        <div className="header-icon">
                            <svg
                                width="21"
                                height="21"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M6 3.5H18C19.1 3.5 20 4.4 20 5.5V18.5C20 19.6 19.1 20.5 18 20.5H6C4.9 20.5 4 19.6 4 18.5V5.5C4 4.4 4.9 3.5 6 3.5Z"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                />
                                <path
                                    d="M8 2V5M16 2V5"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                />
                                <path
                                    d="M8 10H16M8 14H13"
                                    stroke="currentColor"
                                    strokeWidth="1.7"
                                    strokeLinecap="round"
                                />
                            </svg>
                        </div>

                        <div>
                            <h1>غیبت‌های روز</h1>

                            {!isLoading && selectedDate && (
                                <p className="h6 text-light mt-1">
                                    {dayName}، {formattedDate}
                                </p>
                            )}
                        </div>

                    </div>

                    {!isLoading && students.length > 0 && (
                        <a
                            href="#"
                            onClick={getHrefSms}
                            className="sms-all-button"
                        >
                            <svg
                                width="19"
                                height="19"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M20 11.5C20 15.64 16.42 19 12 19C10.85 19 9.76 18.77 8.8 18.36L4 20L5.35 16.17C4.5 14.91 4 13.39 4 11.75C4 7.6 7.58 4.5 12 4.5C16.42 4.5 20 7.36 20 11.5Z"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                    strokeLinejoin="round"
                                />
                                <path
                                    d="M8 11.5H8.01M12 11.5H12.01M16 11.5H16.01"
                                    stroke="currentColor"
                                    strokeWidth="2"
                                    strokeLinecap="round"
                                />
                            </svg>

                            <span>پیام به والدین</span>
                        </a>
                    )}

                </div>

            </header>


            {/* ================= CONTENT ================= */}

            <main className="absence-content">

                {/* Loading */}

                {isLoading && (
                    <div className="loading-state">

                        <div className="loading-spinner">
                            <div className="spinner-border text-primary" />
                        </div>

                        <strong>در حال دریافت اطلاعات</strong>

                        <span>
                            لطفاً چند لحظه صبر کنید...
                        </span>

                    </div>
                )}


                {/* Empty */}

                {!isLoading && students.length === 0 && (
                    <div className="empty-state">

                        <div className="empty-icon">
                            <svg
                                width="34"
                                height="34"
                                viewBox="0 0 24 24"
                                fill="none"
                            >
                                <path
                                    d="M9 11L11 13L15.5 8.5"
                                    stroke="currentColor"
                                    strokeWidth="1.8"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />

                                <path
                                    d="M7 3.5H17C18.1 3.5 19 4.4 19 5.5V18.5C19 19.6 18.1 20.5 17 20.5H7C5.9 20.5 5 19.6 5 18.5V5.5C5 4.4 5.9 3.5 7 3.5Z"
                                    stroke="currentColor"
                                    strokeWidth="1.6"
                                />
                            </svg>
                        </div>

                        <h2>غیبتی ثبت نشده است</h2>

                        <p>
                            برای این روز دانش‌آموز غایبی ثبت نشده است.
                        </p>

                    </div>
                )}


                {/* Students */}

                {!isLoading && students.length > 0 && (

                    <div className="students-list">

                        <div className="list-title">
                            <span>دانش‌آموزان غایب</span>

                            <small>
                                {students.length} نفر
                            </small>
                        </div>


                        {students.map((student) => (

                            <article
                                key={student.studentId}
                                className="student-card"
                            >

                                <div className="student-main">

                                    <div className="student-avatar">
                                        {(student.name || "?").charAt(0)}
                                    </div>

                                    <div className="student-info">

                                        <div className="student-name-row">

                                            <h3>
                                                {student.name}{" "}
                                                {student.family}
                                            </h3>

                                            {student.isAbsence && (
                                                <span className="absence-badge">
                                                    غایب
                                                </span>
                                            )}

                                        </div>

                                        <span className="classroom-name">
                                            {student.classroomName}
                                        </span>

                                    </div>

                                    <div className="student-menu dropdown">

                                        <button
                                            type="button"
                                            className="more-button"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            aria-label="عملیات"
                                        >
                                            <svg
                                                width="20"
                                                height="20"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <circle
                                                    cx="12"
                                                    cy="5"
                                                    r="1.4"
                                                    fill="currentColor"
                                                />
                                                <circle
                                                    cx="12"
                                                    cy="12"
                                                    r="1.4"
                                                    fill="currentColor"
                                                />
                                                <circle
                                                    cx="12"
                                                    cy="19"
                                                    r="1.4"
                                                    fill="currentColor"
                                                />
                                            </svg>
                                        </button>

                                        <ul className="dropdown-menu dropdown-menu-end shadow-sm">

                                            <li>
                                                <button
                                                    type="button"
                                                    className="dropdown-item text-end remove-item"
                                                    disabled={
                                                        removingId ===
                                                        student.studentId
                                                    }
                                                    onClick={() =>
                                                        removeAbsenceHandler(
                                                            student.studentId
                                                        )
                                                    }
                                                >
                                                    {removingId ===
                                                    student.studentId
                                                        ? "در حال حذف..."
                                                        : "حذف غیبت"}
                                                </button>
                                            </li>

                                        </ul>

                                    </div>

                                </div>


                                {/* Parent contact */}

                                {student.parentMobile && (

                                    <a
                                        href={
                                            "tel:" +
                                            student.parentMobile
                                        }
                                        className="parent-contact"
                                    >

                                        <div className="phone-icon">
                                            <svg
                                                width="18"
                                                height="18"
                                                viewBox="0 0 24 24"
                                                fill="none"
                                            >
                                                <path
                                                    d="M7.8 16.2C5.9 14.3 4.5 12 3.7 9.5C3.2 7.9 3.7 6.2 4.9 5L5.6 4.3C6.4 3.5 7.7 3.5 8.5 4.3L10.2 6C11 6.8 11 8.1 10.2 8.9L9.8 9.3C9.4 9.7 9.4 10.4 9.8 10.8L13.2 14.2C13.6 14.6 14.3 14.6 14.7 14.2L15.1 13.8C15.9 13 17.2 13 18 13.8L19.7 15.5C20.5 16.3 20.5 17.6 19.7 18.4L19 19.1C17.8 20.3 16.1 20.8 14.5 20.3C12 19.5 9.7 18.1 7.8 16.2Z"
                                                    stroke="currentColor"
                                                    strokeWidth="1.5"
                                                    strokeLinejoin="round"
                                                />
                                            </svg>
                                        </div>

                                        <div className="parent-contact-text">
                                            <span>شماره تماس والد</span>
                                            <strong>
                                                {student.parentMobile}
                                            </strong>
                                        </div>

                                        <svg
                                            className="contact-arrow"
                                            width="18"
                                            height="18"
                                            viewBox="0 0 24 24"
                                            fill="none"
                                        >
                                            <path
                                                d="M9 18L15 12L9 6"
                                                stroke="currentColor"
                                                strokeWidth="1.8"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            />
                                        </svg>

                                    </a>

                                )}

                            </article>

                        ))}

                    </div>

                )}

            </main>


            {/* ================= STYLE ================= */}

            <style>{`

                * {
                    box-sizing: border-box;
                }

                .absence-page {
                    min-height: 100vh;
                    background: #f6f8fc;
                    color: #182235;
                    font-family: inherit;
                }

                /* HEADER */

                .absence-header {
                    position: sticky;
                    top: 0;
                    z-index: 100;

                    height: 72px;
                    
                    background: #726be7;
                    border-bottom: 1px solid #e8edf4;

                    backdrop-filter: blur(12px);
                }

                .absence-header-inner {
                    width: 100%;
                    max-width: 700px;
                    height: 100%;

                    margin: auto;
                    padding: 0 15px;

                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    gap: 12px;
                }

                .header-title {
                    display: flex;
                    align-items: center;
                    gap: 10px;

                    min-width: 0;
                }

                .back-button,
                .header-icon {
                    width: 42px;
                    height: 42px;

                    flex-shrink: 0;

                    border-radius: 12px;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .back-button {
                    border: 1px solid #e4e9f0;
                    background: #fff;
                    color: #687589;
                }

                .back-button svg {
                    transform: rotate(180deg);
                }

                .header-icon {
                    background: #eaf2ff;
                    color: #2563eb;
                }

                .header-title h1 {
                    margin: 0;

                    font-size: 16px;
                    font-weight: 800;
                    line-height: 1.5;

                    color: #ffffff;
                }

                .header-title span {
                    display: block;

                    margin-top: 2px;

                    font-size: 10px;
                    line-height: 1.5;

                    color: #ffffff;

                    white-space: nowrap;
                }

                .sms-all-button {
                    height: 40px;

                    padding: 0 12px;

                    border-radius: 11px;

                    background: #edf5ff;
                    color: #2563eb;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    gap: 6px;

                    text-decoration: none;

                    font-size: 11px;
                    font-weight: 700;

                    white-space: nowrap;

                    transition: .18s ease;
                }

                .sms-all-button:hover {
                    background: #e2edff;
                    color: #1d4ed8;
                }

                /* CONTENT */

                .absence-content {
                    width: 100%;
                    max-width: 700px;

                    margin: auto;

                    padding: 20px 15px 40px;
                }

                /* SUMMARY */

                .summary-card {
                    padding: 15px;

                    background: #fff;

                    border: 1px solid #e7ebf2;
                    border-radius: 17px;

                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    margin-bottom: 20px;

                    box-shadow:
                        0 3px 14px rgba(30,45,70,.035);
                }

                .summary-info {
                    display: flex;
                    align-items: center;
                    gap: 11px;
                }

                .summary-icon {
                    width: 44px;
                    height: 44px;

                    border-radius: 13px;

                    background: #fff1f3;
                    color: #d81b45;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .summary-info strong {
                    display: block;

                    font-size: 13px;
                    line-height: 1.7;

                    font-weight: 800;
                }

                .summary-info span {
                    display: block;

                    margin-top: 2px;

                    color: #7c8799;

                    font-size: 10px;
                    line-height: 1.7;
                }

                .absence-count {
                    min-width: 51px;
                    height: 51px;

                    border-radius: 14px;

                    background: #fff1f3;
                    color: #d81b45;

                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                }

                .absence-count strong {
                    font-size: 17px;
                    line-height: 1.2;
                    font-weight: 800;
                }

                .absence-count span {
                    margin-top: 1px;

                    font-size: 9px;
                    color: #ba536a;
                }

                /* LIST */

                .students-list {
                    display: flex;
                    flex-direction: column;
                    gap: 10px;
                }

                .list-title {
                    display: flex;
                    align-items: center;
                    justify-content: space-between;

                    padding: 0 3px 4px;
                }

                .list-title span {
                    font-size: 14px;
                    font-weight: 800;
                    color: #253044;
                }

                .list-title small {
                    color: #7d8798;
                    font-size: 14px;
                }

                /* STUDENT CARD */

                .student-card {
                    padding: 14px;

                    background: #fff;

                    border: 1px solid #e7ebf2;
                    border-radius: 17px;

                    box-shadow:
                        0 2px 10px rgba(25,45,75,.03);

                    transition: .18s ease;
                }

                .student-main {
                    display: flex;
                    align-items: center;
                    gap: 11px;
                }

                .student-avatar {
                    width: 43px;
                    height: 43px;

                    flex-shrink: 0;

                    border-radius: 13px;

                    background: #edf4ff;
                    color: #2563eb;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    font-size: 16px;
                    font-weight: 800;
                }

                .student-info {
                    min-width: 0;
                    flex: 1;
                }

                .student-name-row {
                    display: flex;
                    align-items: center;
                    gap: 7px;

                    min-width: 0;
                }

                .student-name-row h3 {
                    margin: 0;

                    font-size: 14px;
                    line-height: 1.7;

                    font-weight: 800;

                    color: #1d293b;

                    white-space: nowrap;
                    overflow: hidden;
                    text-overflow: ellipsis;
                }

                .absence-badge {
                    flex-shrink: 0;

                    padding: 3px 7px;

                    border-radius: 7px;

                    background: #fff0f2;
                    color: #d81b45;

                    font-size: 8px;
                    font-weight: 800;
                }

                .classroom-name {
                    display: block;

                    margin-top: 2px;

                    font-size: 10px;
                    line-height: 1.7;

                    color: #7b8798;
                }

                .student-menu {
                    flex-shrink: 0;
                }

                .more-button {
                    width: 38px;
                    height: 38px;

                    padding: 0;

                    border: 0;
                    border-radius: 10px;

                    background: transparent;
                    color: #8a94a5;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .more-button:hover {
                    background: #f3f5f8;
                    color: #46536a;
                }

                .remove-item {
                    color: #dc3545 !important;
                }

                /* PARENT CONTACT */

                .parent-contact {
                    min-height: 58px;

                    margin-top: 13px;
                    padding: 9px 10px;

                    border: 1px solid #edf0f4;
                    border-radius: 12px;

                    background: #fafbfc;

                    display: flex;
                    align-items: center;

                    gap: 9px;

                    text-decoration: none;

                    color: inherit;

                    transition: .18s ease;
                }

                .parent-contact:hover {
                    background: #f6f9ff;
                    border-color: #dce7f8;
                }

                .phone-icon {
                    width: 34px;
                    height: 34px;

                    border-radius: 10px;

                    background: #eaf7f0;
                    color: #15945c;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    flex-shrink: 0;
                }

                .parent-contact-text {
                    flex: 1;
                    min-width: 0;
                }

                .parent-contact-text span {
                    display: block;

                    font-size: 9px;
                    line-height: 1.5;

                    color: #8a94a5;
                }

                .parent-contact-text strong {
                    display: block;

                    margin-top: 2px;

                    font-size: 12px;
                    line-height: 1.6;

                    color: #344054;

                    direction: ltr;
                    text-align: right;
                }

                .contact-arrow {
                    color: #a1a9b6;
                    transform: rotate(180deg);
                }

                /* LOADING */

                .loading-state {
                    min-height: 55vh;

                    display: flex;
                    flex-direction: column;

                    align-items: center;
                    justify-content: center;

                    text-align: center;
                }

                .loading-spinner {
                    width: 55px;
                    height: 55px;

                    border-radius: 17px;

                    background: #edf4ff;

                    display: flex;
                    align-items: center;
                    justify-content: center;

                    margin-bottom: 15px;
                }

                .loading-spinner .spinner-border {
                    width: 25px;
                    height: 25px;
                }

                .loading-state strong {
                    font-size: 13px;
                    color: #334155;
                }

                .loading-state span {
                    margin-top: 5px;

                    font-size: 10px;
                    color: #8a94a5;
                }

                /* EMPTY */

                .empty-state {
                    min-height: 50vh;

                    padding: 30px;

                    display: flex;
                    flex-direction: column;

                    align-items: center;
                    justify-content: center;

                    text-align: center;
                }

                .empty-icon {
                    width: 76px;
                    height: 76px;

                    margin-bottom: 17px;

                    border-radius: 22px;

                    background: #eaf7f0;
                    color: #15945c;

                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

                .empty-state h2 {
                    margin: 0;

                    font-size: 16px;
                    line-height: 1.7;

                    font-weight: 800;
                }

                .empty-state p {
                    max-width: 300px;

                    margin: 7px 0 0;

                    font-size: 11px;
                    line-height: 1.9;

                    color: #7d8798;
                }

                /* MOBILE */

                @media (max-width: 480px) {

                    .absence-header {
                        height: 68px;
                    }

                    .absence-header-inner {
                        padding: 0 10px;
                    }

                    .header-icon,
                    .back-button {
                        width: 39px;
                        height: 39px;
                    }

                    .header-title h1 {
                        font-size: 14px;
                    }

                    .header-title span {
                        font-size: 14px;
                    }

                    .sms-all-button {
                        border-radius: 11px;
                    }

                    .absence-content {
                        padding: 16px 10px 30px;
                    }

                    .summary-card {
                        padding: 13px;
                        margin-bottom: 17px;
                    }

                    .summary-icon {
                        width: 41px;
                        height: 41px;
                    }

                    .student-card {
                        padding: 13px;
                    }
                }

                @media (min-width: 768px) {

                    .student-card:hover {
                        transform: translateY(-1px);

                        border-color: #d9e3f3;

                        box-shadow:
                            0 8px 24px rgba(25,45,75,.07);
                    }

                }

            `}</style>

        </div>
    );
};

export default DayAbsences;